/**
 * Created by AlexanderC on 6/16/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingCacheException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when missing an item from cache
 */
let MissingCacheException = exports.MissingCacheException = function (_Exception) {
  _inherits(MissingCacheException, _Exception);

  /**
   * @param {String} cacheKey
   */
  function MissingCacheException(cacheKey) {
    _classCallCheck(this, MissingCacheException);

    return _possibleConstructorReturn(this, (MissingCacheException.__proto__ || Object.getPrototypeOf(MissingCacheException)).call(this, `Missing key ${cacheKey} from cache`));
  }

  return MissingCacheException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/Exception/MissingCacheException.js
// module id = 350
// module chunks = 0